import { useState } from 'react';
import Title from './Title'
import Sidebar from "./Sidebar";
import { AiOutlineShoppingCart } from "react-icons/ai";
import {CgProfile} from "react-icons/cg";
import {RxHamburgerMenu} from "react-icons/rx"
import {Link} from 'react-router-dom';
import {useContext} from 'react';
import UserContext from '../utils/UserContext';
import {useSelector} from "react-redux"
import {logOut} from "../utils/authHelper"

const Header = () => {

  const [isExpand, setIsExpand] = useState(false);

  const expandHandler = () => {
    setIsExpand((prevState) => !prevState);
  }

  const logoutHandler = async () => {
    await logOut();
  }

  const {user} = useContext(UserContext);

  const cartItems = useSelector(store => store.cart.items);

  return (
    <div className="flex justify-between h-20 items-center shadow-md mb-2 px-2 text-slate-800">
      {/* Sidebar */}
      {isExpand && <Sidebar />}

      <Title />

      {/* {user.name !== "" && (
        <div className="px-8 font-semibold text-slate-400">{user.name}</div>
      )} */}

      <ul className="hidden md:visible md:flex justify-end gap-2 font-semibold items-center">
        <li className="px-4 py-2 hover:text-cyan-500 ">
          <Link to="/">Home</Link>
        </li>
        <li className="px-4 py-2 hover:text-cyan-500 ">
          <Link to="/instamart">Instamart</Link>
        </li>
        <li className="px-4 py-2 hover:text-cyan-500 ">
          <Link to="/about">About</Link>
        </li>
        {/* <li className="px-4 py-2 hover:text-cyan-500">
          <Link to="/contact">Contact Us</Link>
        </li> */}
        <li className="px-4 py-2 hover:text-cyan-500 ">
          <Link to="/help">Help</Link>
        </li>
        <li className="px-4 py-2 hover:text-cyan-500">
          <Link to="/cart" className="flex text-xl">
            <AiOutlineShoppingCart className="cart-icon" />
            <sup data-testid="cart-count">{cartItems.length}</sup>
          </Link>
        </li>
        <li className="flex items-center px-4 py-2 hover:text-cyan-500 text-xl">
          <CgProfile />
          <span className="text-base rounded-full text-cyan-500 bg-cyan-200 px-2">
            {user.name.slice(0, 7)}
          </span>
        </li>
        <li>
          <button className="px-4 py-2 font-semibold shadow-lg rounded-full hover:text-cyan-500">
            {user.name !== "" ? (
              <Link to="/" onClick={logoutHandler}>
                Logout
              </Link>
            ) : (
              <Link to="/login">Login</Link>
            )}
          </button>
        </li>
      </ul>

      <button
        onClick={expandHandler}
        className="md:hidden text-3xl text-cyan-500 border-4 rounded"
      >
        <RxHamburgerMenu />
      </button>
    </div>
  );
};

export default Header;
